export default __webpack_public_path__ + "static/media/vehicle_back_left.22004b3d.svg";